import { useRef as o, useEffect as i, useCallback as f } from "react";
let l = Symbol();
function p(n) {
  let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
  return Object.assign(n, {
    [l]: t
  });
}
function T() {
  for (var _len = arguments.length, n = new Array(_len), _key = 0; _key < _len; _key++) {
    n[_key] = arguments[_key];
  }
  let t = o(n);
  i(() => {
    t.current = n;
  }, [n]);
  let c = f(e => {
    for (let u of t.current) u != null && (typeof u == "function" ? u(e) : u.current = e);
  }, [t]);
  return n.every(e => e == null || (e == null ? void 0 : e[l])) ? void 0 : c;
}
export { p as optionalRef, T as useSyncRefs };